<template>
    <editing-sub-frame :sub_type="sub_type" :sub_code="sub_code" :sub_guide="sub_data_contents_information">
        <template #head>
            <!--제목, 컴포넌트 기본 공통 -->

            <!--     label이 있는 경우에만 폼 활성화        -->
            <template v-if="label">
                <div class="mt-3 mb-1 fw-600 f-90"> Sub label *</div>
                <b-form-input v-model="sub_label" placeholder="필수 입력"/>
            </template>


            <div class="mt-3 mb-1 fw-600 f-90"> Sub type</div>
            <div class="d-flex justify-content-between">
                <b-dropdown :text="sub_type" variant="dark-border" class="mr-2">
                    <b-dropdown-item-button v-for="(sub_type, sub_type_idx) in sub_types"
                                            :key="`subs-checkbox-subtype-opt-${sub_type}-${sub_type_idx}`"
                                            @click="selectType(sub_type)"
                    >
                        {{ sub_type }}
                    </b-dropdown-item-button>
                </b-dropdown>

                <b-form-input v-model="sub_name" placeholder="Title (필요시 작성)">
                    {{ sub_name }}
                </b-form-input>
            </div>

            <div class="mt-3 mb-1 fw-600 f-90">Description</div>
            <b-textarea v-model="sub_description" placeholder="A1. ㅇㅇㅇ을 관리하고 있습니까?"> {{ sub_description }}</b-textarea>

            <div class="mt-3 mb-1 fw-600 f-90">Info</div>
            <b-textarea v-model="sub_info" placeholder="용어설명, 참고사항, 평가기준 등 답변 참고정보"> {{ sub_info }}</b-textarea>
        </template>

        <template #structure>
            <!-- DF Checkbox 데이터 구조 수정 -->
            <b-card no-body class="border-top-0 border-bottom-0 mb-2">
                <b-table-simple class="mb-0" bordered hover>
                    <tr>
                        <th class="bgray-100"> text</th>
                        <th class="bgray-100"> value</th>
                        <th class="bgray-100"> description</th>
                        <template v-if="sub_data_header.scoring=='auto'">
                            <th class="bgray-100"> 배점(총 10점)</th>
                        </template>
                        <th class="bgray-100"> 삭제</th>
                    </tr>
                    <tr v-for="(item, index) in sub_data_contents.structure"
                        :key="`checkbox-subs-structure-${uidOf(item)}`"
                    >
                        <td>
                            <b-form-input v-model.trim="item.text">{{ item.text }}</b-form-input>
                        </td>
                        <td>
                            <b-form-input v-model.trim="item.value">{{ item.value }}</b-form-input>
                        </td>
                        <td>
                            <b-form-checkbox v-model="is_description_available[index]"
                                             @input="manageDescriptionAvailability(item, index)"
                                             value="true"
                                             unchecked-value="false"
                            >
                                <b-input-group :id="`subs-${sub_code}-checkbox-input-group`">
                                    <b-form-input v-model="item.placeholder"
                                                  placeholder="상세 내용 폼에 표시될 가이드텍스트를 입력해 주세요"
                                                  :disabled="!is_description_available[index]"
                                    >
                                        {{ item.placeholder }}
                                    </b-form-input>

                                    <template #append>
                                        <b-dropdown
                                            :text="item.description_input_type ? description_types[item.description_input_type] : '타입'"
                                            variant="dark" size="sm"
                                            boundary="window"
                                            :disabled="!is_description_available[index]"
                                        >
                                            <b-dropdown-item @click="setDescriptionType(index, 'text')">텍스트
                                            </b-dropdown-item>
                                            <b-dropdown-item @click="setDescriptionType(index, 'number')">숫자
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </template>
                                </b-input-group>
                            </b-form-checkbox>
                        </td>
                        <template v-if="sub_data_header.scoring === 'auto'">
                            <td>
                                <b-form-input type='number' v-model="item.score"></b-form-input>
                            </td>
                        </template>
                        <td>
                            <b-btn class="hj-icon-only-btn" size="sm"
                                   @click="sub_data_contents.structure.splice(index,1)"
                            >
                                <fa icon="trash-alt"></fa>
                            </b-btn>
                        </td>
                    </tr>
                </b-table-simple>
            </b-card>

            <div class="text-right">
                <b-btn @click="addCheckboxItem" variant="blue" size="sm">체크박스 선택지 추가</b-btn>
            </div>
        </template>

        <template #option>
            <!-- Tags, Child 등 기본 공통 -->
            <b-list-group>
                <b-list-group-item>
                    <editing-sub-submit-required v-model="submit_required" :sub_code="sub_code" />
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="첨부문항"
                        :label-for="`editing-subs-checkbox-${sub_code}-has_attachment`"
                        class="align-items-center mb-0"
                    >
                        <b-form-checkbox :id="`editing-subs-checkbox-${sub_code}-has_attachment`"
                                         v-model="has_attachment"
                                         :disabled="required_opt_attachment"
                        >
                            파일 및 URL 첨부
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="선택지별 첨부"
                        :label-for="`editing-subs-checkbox-${sub_code}-required_opt_attachment`"
                        class="align-items-center mb-0"
                    >
                        <b-form-checkbox :id="`editing-subs-checkbox-${sub_code}-required_opt_attachment`"
                                         v-model="required_opt_attachment"
                                         :disabled="has_attachment"
                        >
                            선택지별 첨부 여부
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="첨부필수"
                        :label-for="`editing-subs-checkbox-${sub_code}-required_attachment`"
                        class="align-items-center mb-0"
                    >
                        <b-form-checkbox :id="`editing-subs-checkbox-${sub_code}-required_attachment`"
                                         v-model="required_attachment"
                                         :disabled="!has_attachment && !required_opt_attachment"
                        >
                            첨부필수 문항
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="필수답변"
                        :label-for="`editing-subs-radio-${sub_code}-required_answer`"
                        class="align-items-center mb-0"
                    >
                        <b-form-checkbox :id="`editing-subs-radio-${sub_code}-required_answer`"
                                         v-model="required_answer"
                        >
                            필수답변
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="Risk"
                        :label-for="`editing-subs-checkbox-${sub_code}-risk`"
                        class="align-items-center mb-0"
                    >
                        <b-form-checkbox :id="`editing-subs-checkbox-${sub_code}-risk`"
                                         v-model="sub_risk"
                        >
                            적용
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="Priority"
                        :label-for="`editing-subs-priority-${sub_code}-tags`"
                        class="align-items-center mb-0"
                    >

                        <b-form-select :id="`editing-subs-priority-${sub_code}-tags`"
                                       v-model="sub_priority"
                                       :options="sub_priority_option"
                        />
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="Tags"
                        :label-for="`editing-subs-checkbox-${sub_code}-tags`"
                        class="align-items-center mb-0"
                    >
                        <b-input :id="`editing-subs-checkbox-${sub_code}-tags`" v-model="tags"
                                 placeholder="띄어쓰기 대신 _ 사용, 쉼표로 구분"
                        />
                    </b-form-group>
                </b-list-group-item>
            </b-list-group>
        </template>

        <template #footer>
            <div class="text-right">
                <b-button variant="blue" class="mr-2"
                          @click="handleSaveSub"
                          :disabled="is_saving_subs"
                >
                    <div class="d-flex align-items-center">
                        저장
                        <b-spinner v-show="is_saving_subs" small class="ml-2"/>
                    </div>
                </b-button>
                <b-button @click="$emit('click-cancel')" variant="dark">취소</b-button>
            </div>
        </template>
    </editing-sub-frame>
</template>

<script>
import {EditingSubComponentMixin} from '@core_mixins/EditingSubComponentMixin'

export default {
    name: 'editing-df-checkbox',
    mixins: [
        EditingSubComponentMixin
    ],
    data() {
        return {
            is_description_available: [],
            sub_data_contents_information: `
                text: 체크박스 옆에 표시될 텍스트입니다. 
                value: 체크박스 선택시 저장될 값입니다. text와 같을 수 있습니다. 
                description: 체크박스 옆에 부가 설명을 제공할 수 있는 텍스트입력 폼을 제공할지 결정합니다. 
                placeholder: 텍스트입력 폼에 폼에 표시될 가이드 텍스트입니다. 
            `,
            description_types: {
                text: '일반',
                number: '숫자'
            },
        }
    },
    created() {
        this.initiateDescriptionAvailability()
    },
    methods: {
        async handleSaveSub() {
            if (await this.saveSub()) this.$emit('click-save')
        },
        manageDescriptionAvailability(item, index) {
            this.$nextTick(() => {
                //해당 checkbox 아이템에 대해 description을 쓴다고 체크한 것이면
                if (this.is_description_available[index] == 'true') {
                    this.$set(item, 'description', "")
                    this.$set(item, 'description_input_type', "text")
                    this.$set(item, 'placeholder', "")
                }
                //description을 쓰지 않는다고 체크한 것이면
                else {
                    delete item.description
                    delete item.description_input_type
                    delete item.placeholder
                }
            })
        },
        addCheckboxItem() {
            let new_checkbox_item = {
                text: '',
                value: ''
            }
            if (!this.sub_data_contents.structure) {
                this.$set(this.sub_data_contents, 'structure', [])
            }
            this.sub_data_contents.structure.push(new_checkbox_item)
        },
        initiateDescriptionAvailability() {
            for (let i = 0; i < this.sub_data_contents.structure.length; i++) {
                if (this.sub_data_contents.structure[i].hasOwnProperty('description')) this.is_description_available[i] = true
                else this.is_description_available[i] = false
            }
        },
        setDescriptionType(index, type) {
            this.$set(this.sub_data_contents.structure[index], 'description_input_type', type)
        },
        changeAttachmentCheckbox(item, field, value) {
            this.$set(item, field, value)
        },
    }
}
</script>
